
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/find/[...slug]",
      function () {
        return require("private-next-pages/find/[...slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/find/[...slug]"])
      });
    }
  